/**
 *
 * DateRange/Dropdown
 *
 */

import React, { memo, useState } from 'react'

// NPM Libraries
import { DateRangePicker, defaultStaticRanges, createStaticRanges } from 'react-date-range'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format, startOfMonth, startOfYear, endOfDay, isSameDay, subHours } from 'date-fns'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file

// Components
import Modal from 'components/Modal'

// const Pickers = styled.div`
// 	position: absolute;
// 	top: 100%;
// 	z-index: 1000;
// 	min-width: 10rem;
// 	padding: 0;
// 	margin: 0.125rem 0 0;
// 	font-size: 1rem;
// 	background-color: #ffffff;
// 	border: 1px solid rgba(50, 50, 58, 0.15);
// 	border-radius: 0.25rem;
// 	text-align: center;

// 	.text-left & {
// 		left: 0;
// 	}

// 	.text-right & {
// 		right: 0;
// 	}
// 	.picker-header-start, .picker-header-end {
// 		background-color: ${COLORS.grey_e};
// 		font-weight: 600;
// 		font-size: 18px;
// 		padding: 3px;
// 		position: relative;
// 		z-index: 20003;
// 		margin-bottom: -15px;
// 	}
// 	.picker-header-start{
// 		border-radius: 0.25rem 0 0 0;
// 	}
// 	.picker-header-end{
// 		border-radius: 0 0.25rem 0 0;
// 	}
// 	.picker-flex-wrapper {
// 		display: flex;
// 	}

// 	@media (max-width: 800px){
// 		.picker-flex-wrapper{
// 			flex-wrap: wrap;
// 		}
// 		.picker-header-start{
// 			border-radius: 0.25rem 0.25rem 0 0;
// 		}
// 		.picker-header-end{
// 			border-radius: 0;
// 		}
// 	}

// `

function Dropdown({ start_date, end_date, setStartDate, setEndDate, setRangeDate, disabled, anchor_right, CustomButton }) {
	const [open, setOpen] = useState(false)

	const beginning_of_month = startOfMonth(new Date())
	const beginning_of_year = startOfYear(new Date())

	const [ranges, setRanges] = useState([
		{
			startDate: new Date(start_date),
			endDate: endOfDay(end_date),
			key: 'selection',
		},
	])

	function applyDateRange() {
		if (!disabled) {
			if (setStartDate) setStartDate(new Date(ranges[0].startDate))
			if (setEndDate) setEndDate(endOfDay(ranges[0].endDate))
			if (setRangeDate) setRangeDate(new Date(ranges[0].startDate), endOfDay(ranges[0].endDate))
			setOpen(false)
		}
	}

	return (
		<div className={`p-relative ${anchor_right ? 'text-right' : 'text-left'}`}>
			{CustomButton ? (
				CustomButton({
					onClick: () => setOpen(!open),
				})
			) : (
				<button
					type="button"
					className="btn-unstyled text-muted p-1"
					style={{ textDecoration: 'none' }}
					onClick={() => {
						setOpen(!open)
					}}
				>
					<span className="font-weight-bold" style={{ fontSize: 16 }}>
						{format(start_date, 'MM/dd/yyyy')} – {format(end_date, 'MM/dd/yyyy')}
					</span>
					<FontAwesomeIcon icon="caret-down" className="text-primary ml-2" />
				</button>
			)}
			<Modal show={open} modalDidClose={() => setOpen(false)} style={{ width: 890, boxSizing: 'content-box' }}>
				<DateRangePicker
					onChange={(item) => setRanges([item.selection])}
					showSelectionPreview
					moveRangeOnFirstSelection={false}
					months={2}
					ranges={ranges}
					direction="horizontal"
					staticRanges={[
						...defaultStaticRanges,
						...createStaticRanges([
							{
								label: 'MTD',
								range: () => ({
									startDate: beginning_of_month,
									endDate: endOfDay(new Date()),
								}),
								isSelected: () =>
									isSameDay(ranges[0].startDate, beginning_of_month) &&
									isSameDay(ranges[0].endDate, subHours(endOfDay(new Date()), 12)),
							},
							{
								label: 'YTD',
								range: () => ({
									startDate: beginning_of_year,
									endDate: endOfDay(new Date()),
								}),
								isSelected: () =>
									isSameDay(ranges[0].startDate, beginning_of_year) &&
									isSameDay(ranges[0].endDate, subHours(endOfDay(new Date()), 12)),
							},
						]),
					]}
				/>
				<button
					className="btn btn-success float-right mr-2 mb-2"
					onClick={() => {
						// setDateRange({
						// 	start_date: ranges[0].startDate,
						// 	end_date: subHours(endOfDay(ranges[0].endDate), 12), // Time zones are the worst thing to happent to man-kind
						// })
						applyDateRange()
						setOpen(false)
					}}
				>
					Select Dates
				</button>
			</Modal>
		</div>
	)
}

Dropdown.propTypes = {}

export default memo(Dropdown)
